import axios from "../../axiosClient";

export const getMaintenanceData = async (blockCode: any, signal: any) => {
  const res = await axios.get(
    `/slpapp/Dashboard/GetMaintenanceChartDataByBlockCode`,
    { params: { blockCode: blockCode }, signal }
  );

  return res?.data;
};

export const getBurnChartData = async (
  blockCode: any,
  selectedLocation: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Dashboard/GetBurnChartDataByBlockCode`, {
    signal,
    params: { blockCode: blockCode, displayLevel: selectedLocation },
  });

  return res?.data;
};

export const getBurnChartDataByBlockCodeWithLevelAndLocation = async (
  blockCode: any,
  selectedLocation: any,
  locationtype: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getBurnChartDataByBlockCodeWithLevelAndLocation`,
    {
      signal,
      params: {
        blockCode: blockCode,
        displayLevel: selectedLocation,
        locationtype: locationtype,
      },
      paramsSerializer: {
        encode: (param: string) => encodeURIComponent(param),
      },
    }
  );

  return res?.data;
};
